import { NgModule } from "@angular/core";
import { CodeScannerFormComponent } from './code-scanner-form/code-scanner-form.component';
import { DynamicCodeScannerComponent } from './dynamic-code-scanner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CodeScannerDesignComponent } from './code-scanner-design/code-scanner-design.component';
import { CodeScannerResultComponent } from './code-scanner-result/code-scanner-result.component';

@NgModule({
    declarations: [
        CodeScannerResultComponent,
        CodeScannerDesignComponent,
        CodeScannerFormComponent, DynamicCodeScannerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    exports: [
        CodeScannerFormComponent
    ],
    entryComponents: [
        DynamicCodeScannerComponent
    ]
})
export class CodeScannerModule {}